<script setup lang="ts">
import SiteLayout from './layouts/SiteLayout.vue'
</script>

<template>
  <SiteLayout />
</template>
